import avatar1 from "../assets/img/team/team-1.jpg";
import avatar2 from "../assets/img/team/team-2.jpg";
import avatar3 from "../assets/img/team/team-3.jpg";
import avatar4 from "../assets/img/team/team-4.jpg";
import avatar5 from "../assets/img/team/member-1.jpg";

const testimonialData = [
    {
        id: '01',
        name: 'Mrs S',
        position: 'Northolt',
        des: 'Sukhi Construction Ltd provided good technical work and customer services, I would not hesitate to recommend them',
        avatar: avatar1,
    },
    {
        id: '02',
        name: 'Mrs P',
        position: 'Finchley',
        des: 'Sukhi Construction Ltd are professional, dedicated and hard working',
        avatar: avatar2,
    },
    {
        id: '03',
        name: 'Mrs Reshma',
        position: 'Neasden',
        des: 'Very professional and honest.',
        avatar: avatar3,
    },
    {
        id: '04',
        name: 'Mrs C',
        position: 'Harrow',
        des: 'An honest and reliable company. Attention to detail is paramount for Sukhi Construction Ltd. I would definitely recommend',
        avatar: avatar4,
    },
    {
        id: '05',
        name: 'Mr Tarun',
        position: 'Stanmore',
        des: 'Fast, efficient and reliable, would definitely recommend.',
        avatar: avatar5,
    },
    {
        id: '06',
        name: 'Mr Sheetal',
        position: 'Pinner',
        des: 'We hired SUKHI after he was recommended to us by a friend. He is an honest, hardworking individual who takes pride in his work. Would definitely recommend.',
        avatar: avatar1,
    },
    {
        id: '07',
        name: 'Mr Mat',
        position: 'Barking',
        des: 'SUKHI and his team are very hardworking and professional. They complete every task to a high standard.',
        avatar: avatar2,
    },
    {
        id: '08',
        name: 'Mr Mannish',
        position: 'Stanmore',
        des: 'I heard of SUKHI Constructions from my sister. She had SUKHI come and do an extension on her property. I was so impressed with his work that I asked him for a quotation for building work at my property. SUKHI has good competitive prices and his work is of the highest standard.',
        avatar: avatar3,
    },
    {
        id: '09',
        name: 'Mr Neil',
        position: 'Watford',
        des: 'I was recommended SUKHI Constructions ltd from a work colleague after having a very bad experience with a previous builder. SUKHI reassured me on work he was completing on every step of the way. Not only is he now the builder who has worked on my home he has also become a friend.',
        avatar: avatar4,
    },
    {
        id: '10',
        name: 'Mrs CB',
        position: 'Southall',
        des: 'I could not have asked for a better company to walk me through a life altering change in my life. From start to finish, everyone at Sukhi Construction Ltd made me feel as though there was nothing they would not do. For all the last minute changes and countless questions, nobody made me feel as though I was a bother. They not only built me a house, they gave me a home',
        avatar: avatar5,
    },
    {
        id: '11',
        name: 'Mr William',
        position: 'Stanmore',
        des: 'I would highly recommend SUKHI Constructions ltd. SUKHI himself is a very genuine person who will give you his opinion if asked. He is not one to force his opinion on you but will give you an honest option of what is asked. Very reasonable in price.',
        avatar: avatar1,
    },
];

export default testimonialData;